module.exports = __webpack_public_path__ + "static/media/img_marketing.5be7bb37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_marketing.jpg
// module id = 434
// module chunks = 4